/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AlgoAction } from './AlgoAction';
import {
    AlgoActionFromJSON,
    AlgoActionFromJSONTyped,
    AlgoActionToJSON,
} from './AlgoAction';
import type { AllocationTypesInner } from './AllocationTypesInner';
import {
    AllocationTypesInnerFromJSON,
    AllocationTypesInnerFromJSONTyped,
    AllocationTypesInnerToJSON,
} from './AllocationTypesInner';
import type { RunMode } from './RunMode';
import {
    RunModeFromJSON,
    RunModeFromJSONTyped,
    RunModeToJSON,
} from './RunMode';

/**
 * 
 * @export
 * @interface OptimizationRequest
 */
export interface OptimizationRequest {
    /**
     * 
     * @type {string}
     * @memberof OptimizationRequest
     */
    dataAsOfDate: string;
    /**
     * 
     * @type {string}
     * @memberof OptimizationRequest
     */
    tradeDateOverride?: string;
    /**
     * 
     * @type {AlgoAction}
     * @memberof OptimizationRequest
     */
    algoAction: AlgoAction;
    /**
     * 
     * @type {RunMode}
     * @memberof OptimizationRequest
     */
    runMode?: RunMode;
    /**
     * 
     * @type {Array<AllocationTypesInner>}
     * @memberof OptimizationRequest
     */
    allocationTypes: Array<AllocationTypesInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OptimizationRequest
     */
    accountGuids: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OptimizationRequest
     */
    details?: string;
}



/**
 * Check if a given object implements the OptimizationRequest interface.
 */
export function instanceOfOptimizationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "dataAsOfDate" in value;
    isInstance = isInstance && "algoAction" in value;
    isInstance = isInstance && "allocationTypes" in value;
    isInstance = isInstance && "accountGuids" in value;

    return isInstance;
}

export function OptimizationRequestFromJSON(json: any): OptimizationRequest {
    return OptimizationRequestFromJSONTyped(json, false);
}

export function OptimizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptimizationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dataAsOfDate': json['data_as_of_date'],
        'tradeDateOverride': !exists(json, 'trade_date_override') ? undefined : json['trade_date_override'],
        'algoAction': AlgoActionFromJSON(json['algo_action']),
        'runMode': !exists(json, 'run_mode') ? undefined : RunModeFromJSON(json['run_mode']),
        'allocationTypes': ((json['allocation_types'] as Array<any>).map(AllocationTypesInnerFromJSON)),
        'accountGuids': json['account_guids'],
        'details': !exists(json, 'details') ? undefined : json['details'],
    };
}

export function OptimizationRequestToJSON(value?: OptimizationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data_as_of_date': value.dataAsOfDate,
        'trade_date_override': value.tradeDateOverride,
        'algo_action': AlgoActionToJSON(value.algoAction),
        'run_mode': RunModeToJSON(value.runMode),
        'allocation_types': ((value.allocationTypes as Array<any>).map(AllocationTypesInnerToJSON)),
        'account_guids': value.accountGuids,
        'details': value.details,
    };
}

